import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Doughnut, Bar, getElementAtEvent } from "react-chartjs-2";
import { bucketTopN, toShareRows } from "../../ChartsGroup/DiamondReportsCharts/_shared/bucketTopN";
import CustomLegend from "../../ChartsGroup/DiamondReportsCharts/_shared/CustomLegend";
import ChartState from "../../ChartsGroup/DiamondReportsCharts/_shared/ChartState";
import { donutOptions, barOptions, donutPctOptions, barPctOptions } from "../../ChartsGroup/DiamondReportsCharts/_shared/chartTheme";
import { GLOBAL_REPORT_PERCENT_ONLY } from "../_shared/globalReportSettings";

// Global's chart endpoints (Admin_JewelryCategoryChartColunmData) return a
// typed response, camelCased on the wire -- "category"/"count" (lowercase),
// unlike the Dealer stack's raw-DataTable "Category"/"count" mix. Same
// bucketing/click-to-drill pattern as JewelryCategoryComp.js otherwise.
const GlobalJewelryCategoryComp = ({ data, loading, onSliceClick, onChartTypeChange }) => {
  const { t } = useTranslation();
  const [chartType, setChartType] = useState("doughnut");
  useEffect(() => { onChartTypeChange?.(chartType); }, [chartType]);
  const chartRef = useRef();

  const { chartData, colors } = bucketTopN(data || [], {
    labelKey: "category",
    valueKey: "count",
    chartLabel: "Category",
    othersLabel: t("Others"),
  });
  const rows = chartData.slice(1);

  const handleClick = (event) => {
    if (!onSliceClick || !chartRef.current) return;
    const [el] = getElementAtEvent(chartRef.current, event);
    if (!el) return;
    const label = rows[el.index]?.[0]?.replace(/\s*\([^)]*\)\s*$/, "");
    if (label && label !== t("Others")) onSliceClick(label);
  };

  const chartJsData = {
    labels: rows.map((row) => row[0]),
    datasets: [
      {
        data: (GLOBAL_REPORT_PERCENT_ONLY ? toShareRows(rows) : rows).map((row) => row[1]),
        backgroundColor: colors,
        borderColor: "#fff",
        borderWidth: chartType === "doughnut" ? 2 : 0,
        borderRadius: chartType === "bar" ? 4 : 0,
      },
    ],
  };

  return (
    <div className="edr-panel mt-4">
      <div className="edr-panel-head">
        <label>
          <b> {t("Jewelry Category Clicks")} </b>
        </label>
        <div className="edr-seg">
          <button className={chartType === "doughnut" ? "edr-on" : ""} onClick={() => setChartType("doughnut")}>{t("Donut")}</button>
          <button className={chartType === "bar" ? "edr-on" : ""} onClick={() => setChartType("bar")}>{t("Bar")}</button>
        </div>
      </div>
      <div className="chart__section" style={{ display: "flex", justifyContent: "center", flexDirection: "column" }}>
        {!loading && rows.length > 0 ? (
          <>
            {chartType === "doughnut" && <CustomLegend chartData={chartData} colorData={colors} />}
            <div className="edr-chartwrap edr-tall">
              {chartType === "doughnut" ? (
                <Doughnut ref={chartRef} data={chartJsData} options={GLOBAL_REPORT_PERCENT_ONLY ? donutPctOptions : donutOptions} onClick={handleClick} />
              ) : (
                <Bar ref={chartRef} data={chartJsData} options={(GLOBAL_REPORT_PERCENT_ONLY ? barPctOptions(true) : barOptions(true))} onClick={handleClick} />
              )}
            </div>
          </>
        ) : (
          <ChartState loading={loading} />
        )}
      </div>
    </div>
  );
};

export default GlobalJewelryCategoryComp;
